window.ttx = window.ttx || {};
ttx.todo = {};

ttx.todo._instances = [];
ttx.todo._seed = 1;

ttx.todo._defaultOptions = {
    type: 'info',
    title: '',
    subtitle: '',
    time: '',
    duration: 3000,
    position: 'top-right',
    offset: 16,
    gap: 10,
    zIndex: 6000,
    closable: true,
    onClose: null
};

ttx.todo._mergeOptions = function (options) {
    return { ...ttx.todo._defaultOptions, ...(options || {}) };
};

ttx.todo._calculateTopOffset = function () {
    const visibleInstances = ttx.todo._instances.filter(function (id) {
        return id && typeof id.close === 'function';
    });

    if (visibleInstances.length === 0) {
        return ttx.todo._defaultOptions.offset;
    }

    let totalHeight = ttx.todo._defaultOptions.offset;
    visibleInstances.forEach(function (instance) {
        const element = document.getElementById(instance.id);
        if (element) {
            totalHeight += element.offsetHeight + ttx.todo._defaultOptions.gap;
        } else {
            totalHeight += 96 + ttx.todo._defaultOptions.gap;
        }
    });

    return totalHeight;
};

ttx.todo._create = function (options) {
    const opts = ttx.todo._mergeOptions(options);

    const iconMap = {
        success: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 7L10 17L5 12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
        error: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>',
        warning: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 7V13" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="17" r="1.2" fill="currentColor"/></svg>',
        info: '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M12 10V16" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/><circle cx="12" cy="7.5" r="1.2" fill="currentColor"/></svg>'
    };

    const colorMap = {
        success: '#52c41a',
        error: '#ff4d4f',
        warning: '#faad14',
        info: '#1677ff'
    };

    const id = 'tx-todo-' + ttx.todo._seed++;
    const topOffset = ttx.todo._calculateTopOffset();

    const container = document.createElement('div');
    container.id = id;
    container.style.cssText = `
        position: fixed;
        top: ${topOffset}px;
        right: ${opts.offset}px;
        max-width: 420px;
        min-width: 320px;
        min-height: 56px;
        padding: 6px 10px;
        background: rgba(255,255,255,0.12);
        border-radius: 8px;
        box-shadow: 0 8px 28px rgba(0,0,0,.14), 0 2px 10px rgba(0,0,0,.1);
        backdrop-filter: blur(8px);
        -webkit-backdrop-filter: blur(8px);
        z-index: ${opts.zIndex};
        display: flex;
        align-items: flex-start;
        gap: 12px;
        animation: tx-todo-slide-in 0.3s ease-out;
        overflow: hidden;
    `;

    const iconColor = colorMap[opts.type] || colorMap.info;

    const icon = document.createElement('div');
    icon.innerHTML = iconMap[opts.type] || iconMap.info;
    icon.style.cssText = `
        width: 22px;
        height: 22px;
        min-width: 22px;
        border-radius: 50%;
        color: ${iconColor};
        background: ${iconColor}1f;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 2px;
    `;
    const iconSvg = icon.firstElementChild;
    if (iconSvg) {
        iconSvg.style.width = '15px';
        iconSvg.style.height = '15px';
        iconSvg.style.display = 'block';
    }

    const body = document.createElement('div');
    body.style.cssText = `
        flex: 1;
        min-width: 0;
    `;

    const title = document.createElement('div');
    title.textContent = opts.title || '';
    title.style.cssText = `
        font-size: 15px;
        font-weight: 600;
        color: #222;
        line-height: 1.5;
        margin-bottom: 4px;
        word-break: break-word;
    `;

    const subtitle = document.createElement('div');
    subtitle.textContent = opts.subtitle || '';
    subtitle.style.cssText = `
        font-size: 13px;
        color: #333;
        line-height: 1.6;
        word-break: break-word;
        white-space: normal;
        overflow-wrap: break-word;
        margin-bottom: 6px;
        cursor: pointer;
    `;

    subtitle.addEventListener('mouseenter', function () {
        subtitle.style.textDecoration = 'underline';
    });
    subtitle.addEventListener('mouseleave', function () {
        subtitle.style.textDecoration = 'none';
    });

    const time = document.createElement('div');
    time.textContent = opts.time || '';
    time.style.cssText = `
        font-size: 12px;
        color: #666;
        line-height: 1.4;
    `;

    if (opts.title) {
        body.appendChild(title);
    }
    if (opts.subtitle) {
        body.appendChild(subtitle);
    }

    container.appendChild(icon);
    container.appendChild(body);

    let closeBtn = null;
    if (opts.closable) {
        closeBtn = document.createElement('button');
        closeBtn.innerHTML = '×';
        closeBtn.type = 'button';
        closeBtn.style.cssText = `
            width: 20px;
            height: 20px;
            border: none;
            background: transparent;
            cursor: pointer;
            font-size: 18px;
            color: #777;
            padding: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            margin-top: 1px;
        `;
        closeBtn.addEventListener('mouseenter', function () {
            closeBtn.style.color = '#222';
            closeBtn.style.background = 'rgba(0,0,0,.06)';
        });
        closeBtn.addEventListener('mouseleave', function () {
            closeBtn.style.color = '#777';
            closeBtn.style.background = 'transparent';
        });
        container.appendChild(closeBtn);
    }

    document.body.appendChild(container);

    let timer = null;
    let closed = false;

    const close = function (trigger) {
        if (closed) return;
        closed = true;

        if (timer) {
            clearTimeout(timer);
            timer = null;
        }

        container.style.animation = 'tx-todo-fade-out 0.2s ease-in';

        setTimeout(function () {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
            }
            const index = ttx.todo._instances.indexOf(instance);
            if (index > -1) {
                ttx.todo._instances.splice(index, 1);
            }
            if (typeof opts.onClose === 'function') {
                opts.onClose(trigger);
            }
        }, 200);
    };

    if (closeBtn) {
        closeBtn.addEventListener('click', function () {
            close('manual');
        });
    }

    if (opts.duration > 0) {
        timer = setTimeout(function () {
            close('timeout');
        }, opts.duration);
    }

    const instance = {
        id,
        close,
        element: container
    };

    ttx.todo._instances.push(instance);

    return {
        id,
        close,
        element: container
    };
};

ttx.todo.show = function (options) {
    return ttx.todo._create(options);
};

ttx.todo.success = function (title, subtitle, time, options) {
    return ttx.todo._create({
        ...options,
        type: 'success',
        title,
        subtitle,
        time
    });
};

ttx.todo.error = function (title, subtitle, time, options) {
    return ttx.todo._create({
        ...options,
        type: 'error',
        title,
        subtitle,
        time
    });
};

ttx.todo.warning = function (title, subtitle, time, options) {
    return ttx.todo._create({
        ...options,
        type: 'warning',
        title,
        subtitle,
        time
    });
};

ttx.todo.info = function (title, subtitle, time, options) {
    return ttx.todo._create({
        ...options,
        type: 'info',
        title,
        subtitle,
        time
    });
};

ttx.todo.close = function (id) {
    if (!id) return;
    const instance = ttx.todo._instances.find(function (item) {
        return item && item.id === id;
    });
    if (instance && typeof instance.close === 'function') {
        instance.close();
    }
};

ttx.todo.closeAll = function () {
    const instances = ttx.todo._instances.slice();
    instances.forEach(function (instance) {
        if (instance && typeof instance.close === 'function') {
            instance.close();
        }
    });
};

if (typeof document !== 'undefined') {
    const style = document.createElement('style');
    style.textContent = `
        @keyframes tx-todo-slide-in {
            from {
                transform: translateX(100%);
                opacity: 0;
            }
            to {
                transform: translateX(0);
                opacity: 1;
            }
        }

        @keyframes tx-todo-fade-out {
            from {
                transform: translateX(0);
                opacity: 1;
            }
            to {
                transform: translateX(100%);
                opacity: 0;
            }
        }
    `;
    document.head.appendChild(style);
}
